import { GraphQLClient } from 'graphql-request';
import {
  AI_FLOW_BY_TITLE_AND_ACTIVE_QUERY,
  AI_FLOW_BY_TITLE_AND_ACTIVE_BASE_QUERY,
} from '../gql/ai-prompts-gql';
import { AIFlowQueryResult } from '../types.ts/ai_prompts';
import { LogManager } from '@src/utility/Logger';

const logger = LogManager.getLogger('aiFlow:queryHelper');

/**
 * Loads an AI flow query result with graceful fallback.
 * Tries the extended query (with model link fields) first,
 * then falls back to the base query if the migration hasn't run yet.
 */
export async function loadFlowQueryResult(
  gqlClient: GraphQLClient,
  variables: { title: string },
): Promise<AIFlowQueryResult | null> {
  let result: { aiFlow: AIFlowQueryResult };
  try {
    result = (await gqlClient.request(
      AI_FLOW_BY_TITLE_AND_ACTIVE_QUERY,
      variables,
    )) as { aiFlow: AIFlowQueryResult };
  } catch (extendedErr) {
    logger.warn('AI flow query with model links failed, falling back to base query', extendedErr);
    try {
      result = (await gqlClient.request(
        AI_FLOW_BY_TITLE_AND_ACTIVE_BASE_QUERY,
        variables,
      )) as { aiFlow: AIFlowQueryResult };
    } catch (err) {
      logger.error('Error loading AI flow', err);
      return null;
    }
  }
  return result?.aiFlow ?? null;
}
